import styled from 'styled-components'

const ProgressStyled = styled.div`
  justify-content: center;
  display: flex;
  align-items: center;
`
export default ProgressStyled
